module.exports = __webpack_public_path__ + "img/banner.e5142e03.png";